// tslint:disable:export-name
export const NO_VALUE: number = -3.1415926535;
